import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, BookOpen, Users, ShieldCheck, Lock, CreditCard, Star, Layers, Gift, CheckCircle2 } from 'lucide-react';
const featured = [{
  icon: FileText,
  text: '100% PDF'
}, {
  icon: Zap,
  text: 'Acceso en 5 min'
}, {
  icon: BookOpen,
  text: 'Silabeo → Fluidez → Comprensión'
}, {
  icon: Users,
  text: 'Para Padres'
}];
const muted = [{
  icon: ShieldCheck,
  text: 'Garantía 7 días'
}, {
  icon: Lock,
  text: 'Pago seguro'
}, {
  icon: CreditCard,
  text: 'Mercado Pago'
}, {
  icon: Star,
  text: '+200 Familias confían'
}, {
  icon: Layers,
  text: '5 Tomos listos'
}, {
  icon: Gift,
  text: '3 Bonos incluidos'
}, {
  icon: Star,
  text: '4.9/5 Calificación'
}, {
  icon: CheckCircle2,
  text: 'Sistema completo'
}];
export function TrustBar() {
  return <section className="bg-white pb-10 pt-2 overflow-hidden" data-id="element-311">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-312">
        {/* Featured badges — elevated white cards in a centered tapering cluster */}
        <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-313">
          {featured.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-center gap-2.5 bg-white rounded-2xl px-5 py-3.5 shadow-lg shadow-slate-200/60 border border-slate-100" data-id="element-314">
              <item.icon className="w-5 h-5 text-gold flex-shrink-0" data-id="element-315" />
              <span className="text-sm md:text-base font-semibold text-navy whitespace-nowrap" data-id="element-316">
                {item.text}
              </span>
            </motion.div>)}
        </div>

        {/* Muted assurance / social badges — plain inline, centered */}
      </div>
    </section>;
}